import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline/periodScale';

const PeriodTitle = ({ scale }) => {
  switch (scale) {
    case PERIOD_SCALE_ENUM.DAYS:
      return <FormattedMessage id="chart.today" />;
    case PERIOD_SCALE_ENUM.WEEKS:
      return <FormattedMessage id="chart.thisWeek" />;
    case PERIOD_SCALE_ENUM.MONTHS:
      return <FormattedMessage id="chart.thisMonth" />;
    case PERIOD_SCALE_ENUM.QUARTERS:
      return <FormattedMessage id="chart.thisQuarter" />;
    case PERIOD_SCALE_ENUM.YEARS:
      return <FormattedMessage id="chart.thisYear" />;
    default:
      return null;
  }
};

PeriodTitle.propTypes = {
  scale: PropTypes.oneOf([
    PERIOD_SCALE_ENUM.DAYS,
    PERIOD_SCALE_ENUM.WEEKS,
    PERIOD_SCALE_ENUM.MONTHS,
    PERIOD_SCALE_ENUM.QUARTERS,
    PERIOD_SCALE_ENUM.YEARS
  ]).isRequired
};

export default PeriodTitle;
